import { DatePickerPopup2Component } from './../base-components/date-picker-popup/date-picker-popup.component';
import { BaseNumberInput } from './../base-components/input/number-input/base-number-input';
import { Url } from 'url';
import { List } from 'immutable';
import { QueryParameter } from './../base-models/query-parameter';
import { DropdownComponent } from './../base-components/dropdown/dropdown.component';
import { FormType } from './../base-models/form-type';
import { AfterViewInit, ViewChild, ElementRef, HostListener, Optional, Inject, forwardRef } from '@angular/core';
import { ParentProperty } from './../base-models/parent-property';
import { Subscription, Observable, BehaviorSubject, of, throwError, Subject, EMPTY } from 'rxjs';
import { ModelData } from './../base-models/model-data';
import { OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { BaseEntity } from './../base-models/base-entity';
import { BaseDataService } from './../base-services/base-data.service';
import { BaseContainerService } from './containers/services/base-container-service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from './base-component';
import { FormGroup, FormControl, Validators, AbstractControl, Validator, ValidationErrors, FormArray } from '@angular/forms';
//import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { BaseInlineContainer } from './containers/base-inline-container';
import { DropdownPicklistComponent } from '../base-components/dropdown/dropdownPicklist/dropdownPicklist.component';
import { ModalService } from '../base-services/modal.service';
import { InputComponent } from '../base-components/input/input/input.component';
import { FormControlData } from '../base-models/form-control-data';
import { catchError, concatMap, map, switchMap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { DefaultUpdateButtonsComponent } from '../base-components/default-update-buttons/default-update-buttons.component';
// import { ConfirmationDialogButtons, DefaultButtonsConfig } from '../../public_api';
import { ConfirmationDialogButtons } from '../base-components/confirmation-dialog/confirmation-dialog-buttons';
import { DefaultButtonsConfig } from '../base-models/default-buttons-config';
import { from } from 'rxjs';
import { MultiselectComponent } from '../base-components/dropdown/multiselect/multiselect.component';
import { error } from 'console';
import { NotificationService } from '../base-services/notification-service';
import { TextAreaComponent } from '../base-components/input/text-area/text-area.component';
import { DateTimePickerPopupComponent } from '../base-components/date-time-picker-popup/date-time-picker-popup.component';
import { ObjectCompareUtil } from '../base-services/object-compare.util';
// import { ToastrService } from 'ngx-toastr';
//import * as ts from 'typescript';

export class BaseUpdateComponent<T extends BaseEntity>
    //extends BaseComponent
    implements OnInit, OnDestroy, AfterViewInit {
    // constructor(
    //     protected activatedRoute: ActivatedRoute,
    //     //protected containerService: BaseContainerService<T>,
    //     protected baseDataService: BaseDataService,
    //     protected notificationsService: NotificationsService,
    //     @Optional() @Inject(TranslateService) protected translateService?: TranslateService,
    //     @Optional() @Inject(ModalService) protected modalService?: ModalService,
    //     @Optional() @Inject(Router) protected router?: Router
    // ){
    //     //super(activatedRoute);
    // }

    constructor(
        protected activatedRoute: ActivatedRoute,
        //protected containerService: BaseContainerService<T>,
        protected baseDataService: BaseDataService,
        protected toastrService: NotificationService,
        @Optional() @Inject(TranslateService) protected translateService?: TranslateService,
        @Optional() @Inject(ModalService) protected modalService?: ModalService,
        @Optional() @Inject(Router) protected router?: Router
    ){
        //super(activatedRoute);
    }

    Item: T = <T>{};
    SavedItem: T;
    errorMessages: any = {};
    SavedViewItem;
    Useridlk: number;
    // Editable: boolean;
    // initialControlDisabledStatus: { [key: string]: boolean } = {}; // Object to store disabled status for each control
    disabledControlsState : any = {};
    // private saveItemCompleted = new Subject<void>();
    saveItemCompleted = new Subject<void>();
    callDelete: boolean = false;
    saveDisabled: boolean = false;
    resetDisabled: boolean = false;
    buttonsConfig: DefaultButtonsConfig;

    @Input() set ModelData(value: ModelData){
        if (!value || !value.MainList) {
            console.warn('BaseUpdateComponent.ModelData: MainList is undefined, skipping init.', value);
            this.modelData = value;   // čisto da ne bude potpuno izgubljeno
            return;
        }    

        this.modelData = value;
        this.buttonsConfig=this.modelData.MainList.DefaultListButtonsConfig;

        if(this.modelData.MainList.FormType == FormType.Reactive)
            this.getFormGroupFromModel();

        if(this.modelData.MainList.LoadFormControlDataOnInit)
            this.getFormControlData(this.modelData.MainList.FormControlDataName);

    }

    private _parentPropertyName: string;
    @Input() set ParentPropertyName(value: string){
            this._parentPropertyName = value;
            this.parentProperty = new ParentProperty(this._parentPropertyName, this._parentPropertyValue);
        }
    
    private _parentPropertyValue: number;
    @Input() set ParentPropertyValue(value: number){
        this._parentPropertyValue = value;
        this.parentProperty = new ParentProperty(this._parentPropertyName, this._parentPropertyValue);
    }

    @Input() set ID(value: number) {
        // console.log('BaseUpdateComponent:' + "set ID");

        if (!this.canDeactivate()) {
            this.modalService.ShowConfirmationDialog(
                "Obaveštenje",
                "Postoje promene u tekućim podacima. Akcijom koju ste pokrenuli promene neće biti sačuvane.",
                "question",
                ConfirmationDialogButtons.ConfirmCancel
            ).result.then((result) => {
                if (result === ConfirmationDialogButtons.ConfirmCancel || result === true) {
                    this.NastaviPostavljanjeID(value);
                }
            }).catch(() => {
                return;
            });
            return;
        }

        this.NastaviPostavljanjeID(value);
    }

     protected refreshSavedState(): void {
        this.SavedItem = this.baseFormGroup.getRawValue();
        this.baseFormGroup.markAsPristine();
        this.baseFormGroup.markAsUntouched();
    }

    private NastaviPostavljanjeID(value: number) {
        this.submitted = false;
        this.Item = <T>{ ID: -1 };

        // if (value <= 0 && this.modelData.MainList.FormType == FormType.Reactive) {
        //     this.getFormGroupFromModel();
        // }

        this._id = value;

        if (this._id > 0) {
            this.Item.ID = value;
            this.Load(this._id).subscribe(() => {
                this.focus();
            });
        } else if (this.modelData.MainList.FormType == 'reactive') {
            this.baseFormGroup.reset(this.emptyMaster);
            this.baseFormGroup.enable();
            this.restoreFormDisabledState(this.baseFormGroup, this.disabledControlsState);

            if (this.baseInlineContainer && this.baseInlineContainer.baseInlineUpdateComponent)
                this.baseInlineContainer.baseInlineUpdateComponent.saveDisabled = false;

            if (this.baseInlineContainer1 && this.baseInlineContainer1.baseInlineUpdateComponent)
                this.baseInlineContainer1.baseInlineUpdateComponent.saveDisabled = false;

            if (this.baseInlineContainer2 && this.baseInlineContainer2.baseInlineUpdateComponent)
                this.baseInlineContainer2.baseInlineUpdateComponent.saveDisabled = false;

            if (this.baseInlineContainer && this.baseInlineContainer.baseInlineUpdateComponent 
                && this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.nestedInlineContainer
                && this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.nestedInlineContainer.baseInlineUpdateComponent)
                    this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.nestedInlineContainer.baseInlineUpdateComponent.saveDisabled = false;


            this.SavedItem = this.baseFormGroup.getRawValue();
            this.IDProcessed.next(true);
            this.focus();
        }
    }

    
    @Input() set parentProperty(value: ParentProperty){
        //console.log('BaseUpdateComponent:'+ "set parentProperty");
        this._parentProperty = value;
        this.baseFormGroup.reset(this.emptyMaster);
        this.SavedItem = this.baseFormGroup.getRawValue();
    }
    @Input() Parameters: List<List<QueryParameter>>;
    @Output() ItemSaved: EventEmitter<T> = new EventEmitter<T>();
    @Output() IDProcessed = new BehaviorSubject<boolean>(false);
    @Output() ItemDeleted = new EventEmitter<T>();
    @Output() SaveProcessed = new EventEmitter<boolean>();
    @Output() ItemLoaded: EventEmitter<T> = new EventEmitter<T>();

    @ViewChild('autofocus', /* TODO: add static flag */ {static: false}) autofocusElement: ElementRef;
    @ViewChild('baseInlineContainer', /* TODO: add static flag */ {static: true}) baseInlineContainer: BaseInlineContainer<T>;
    @ViewChild('baseInlineContainer1', /* TODO: add static flag */ {static: true}) baseInlineContainer1: BaseInlineContainer<T>;
    @ViewChild('baseInlineContainer2', /* TODO: add static flag */ {static: true}) baseInlineContainer2: BaseInlineContainer<T>;

    @ViewChild('nestedInlineContainer', {static: true}) nestedInlineContainer :BaseInlineContainer<T>;
    

    @HostListener('keydown', ['$event'])
    onkeydown(event){
        //if(event.keyCode == 13 && event.target.className != 'btn btn-primary')
            //this.SaveItem();
    }

    @HostListener('window:beforeunload', ['$event'])
    unloadNotification($event: any){
        //console.log('unloadNotification');
        if(!this.canDeactivate())
            $event.returnValue = true;
    }
    // 01.04.2025
    public ItemsLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public baseFormGroup: FormGroup = new FormGroup({});
    emptyMaster;
    emptyDetail;
    submitted: boolean = false;
    modelData: ModelData;
    TransferParameters: List<List<QueryParameter>> = List([]);
    formControlData: FormControlData[];
    //isVisible: FormControlData[] = [];
    fcd: FormControlData[] =[];

    get fc() { return this.baseFormGroup.controls; }
    get ParentProperty() { return this._parentProperty; }

    private selectedIDSubscription: Subscription;
    private _id: number;
    private _parentProperty: ParentProperty = null;
    private _formSaved: boolean = false;

    ngOnInit(){
        // this.saveInitialControlDisabledStatus();

        //super.ngOnInit();

        //if(!this.selectedIDSubscription)
            //this.selectedIDSubscription = this.containerService.SelectedID.subscribe(ID => {
                //this.Item = <T>{ ID: -1};
                //if(ID > 0)
                    //this.Load(ID);
            //})
        //if(this.modelData.MainList.FormType == 'reactive')
            //this.getFormGroupFromModel();

        //this.activatedRoute.snapshot;
            //.subscribe(data => {

            //})
        //if(this.router)
            //this.getFormControlData('FakDokument');
            //.subsctibe(url => {

            //})
    }

    ngOnDestroy(){
        if(this.selectedIDSubscription)
            this.selectedIDSubscription.unsubscribe();

        this.baseFormGroup.reset();
    }

    ngAfterViewInit(){
console.log('baseInlineContainer:', this.baseInlineContainer);
console.log('baseInlineContainer1:', this.baseInlineContainer1);

        this.focus();
        //alert('base update after view init');
    }

    Load(ID: number): Observable<number> {
        //console.log('BaseUpdateComponent:'+ "Load");
        let subject = new Subject<number>();
      this.SavedItem = null;
      this.ItemsLoaded.next(false); // ⬅️ Reset pre početka učitavanja
        // return this.baseDataService.GetByID(this.modelData.MainList.ModelName, ID, this.modelData.MainList.ModelClass)
        //     .pipe(map((data: T) => {
        //         this.Item = data;
                
        //         if(this.modelData.MainList.FormType == 'reactive'){
        //             this.baseFormGroup.setValue(this.Item);
        //             this.SavedItem = this.baseFormGroup.getRawValue();
        //             this.IDProcessed.next(true);
        //             this.Useridlk = this.Item.Useridlk;
        //         }
        //         return this.Item.ID;
                
        //     }));
        
        this.baseDataService.GetByID(this.modelData.MainList.ModelName, ID, this.modelData.MainList.ModelClass)
            .subscribe((data: T) => {
                this.Item = data;
                
                if(this.modelData.MainList.FormType == 'reactive'){
                    this.ItemLoaded.emit(this.Item);
                    // this.baseFormGroup.patchValue(this.Item);
                    // this.SavedItem = this.baseFormGroup.getRawValue();
                    this.baseFormGroup.patchValue(this.Item, { emitEvent: false });
                    this.baseFormGroup.markAsPristine();
                    this.baseFormGroup.markAsUntouched();
                    this.SavedItem = this.baseFormGroup.getRawValue();
                    this.ItemLoaded.emit(this.Item);
                    
                    if (this.Item.Editable){
                        this.baseFormGroup.enable();
                        if (this.baseInlineContainer && this.baseInlineContainer.baseInlineUpdateComponent)
                            this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.baseFormGroup.enable();
                        if (this.baseInlineContainer1 && this.baseInlineContainer1.baseInlineUpdateComponent)
                            this.baseInlineContainer1.baseInlineUpdateComponent.baseUpdateComponent.baseFormGroup.enable();
                        if (this.baseInlineContainer2 && this.baseInlineContainer2.baseInlineUpdateComponent)
                            this.baseInlineContainer2.baseInlineUpdateComponent.baseUpdateComponent.baseFormGroup.enable();

                        if (this.baseInlineContainer && this.baseInlineContainer.baseInlineUpdateComponent 
                            && this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.nestedInlineContainer
                             && this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.nestedInlineContainer.baseInlineUpdateComponent)
                            this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.nestedInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.baseFormGroup.enable();
                    }
                    
                    this.IDProcessed.next(true);   
                    this.Useridlk = this.Item.Useridlk;                 
                    // if (!this._parentProperty)
                    //     this.Editable = this.Item.Editable;
                }
                if (this.Item.Editable == false) 
                    this.baseFormGroup.disable();               
                else{
                    // 01.12.2023
                    this.baseFormGroup.enable();
                    this.restoreFormDisabledState(this.baseFormGroup, this.disabledControlsState);
                }
                this.ItemsLoaded.next(true); // ✅ Označi da je dokument spreman
                    

                // this.ItemLoaded.emit(this.Item);
                subject.next(this.Item.ID);
            });
        return subject.asObservable();
    }

    SaveItem_old(){
        this.submitted = true;

        if(this.baseFormGroup.valid){
        if(this.modelData.MainList.FormType == 'reactive'){
            let tempID = this.Item.ID;
            this.Item = this.baseFormGroup.getRawValue();
            this.Item.ID = tempID;
        }
        if(this._parentProperty){
            if(!this.Item.hasOwnProperty(this._parentProperty.Name)) {
                throw 'Item does not have parent property ' + this._parentProperty.Name;
            }
            this.Item[this._parentProperty.Name] = this._parentProperty.Value;
            if(!this.Item[this._parentProperty.Name] || this.Item[this._parentProperty.Name] <= 0)
            {
                // this.notificationsService.warn('Dokument nije sačuvan', 'Unos stavke');
                this.toastrService.warning('Dokument nije sačuvan', 'Unos stavke');
                return;
            }
        }
        if(this.modelData.MainList.GetParameters != null && this.modelData.MainList.GetParameters.length > 0){
            let parameterName = this.modelData.MainList.GetParameters[0].Name[0].toUpperCase() + this.modelData.MainList.GetParameters[0].Name.substring(1);
            this.Item[parameterName] = this.modelData.MainList.GetParameters[0].Value;
            //this.Item[this.modelData.MainList.GetParameters[0].Name] = this.modelData.MainList.GetParameters[0].Value;
        }

        this.baseDataService.Save(this.modelData.MainList.ModelName, this.Item, this.modelData.MainList.ModelClass, this.modelData.MainList.ShortModelClass)
            .subscribe((data: T) => {
                //console.log('BaseUpdateComponent:'+ "Save");
                //this.containerService.EmitItem(data);
                this.submitted = false;
                this.ItemSaved.emit(data);
                this.SavedViewItem = data;
                //this.Item = <T>{ID: -1};
                this.Item.ID = data.ID;
                if(data[this.modelData.MainList.DefaultPropertyName] && this.Item[this.modelData.MainList.DefaultPropertyName]) {
                    this.Item[this.modelData.MainList.DefaultPropertyName] = data[this.modelData.MainList.DefaultPropertyName];
                }
                //this.baseDataService.GetByID(this.modelData.MainList.ModelName, this.Item.ID, this.modelData.MainList.ModelClass)
                    //.subscribe((data: T) => {
                        //if(this.Item['BrojDokumenta'] != data['BrojDokumenta'])
                            //this.notificationsService.warn('Sačuvani dokument sadrži automatski korigovane podatke');
                        //this.Item = data;
                        //this.baseFormGroup.setValue(this.Item);
                        this.baseFormGroup.patchValue(this.Item);
                        //this.SavedItem = this.baseFormGroup.getRawValue();
                    //})
                //this.baseFormGroup.get('ID').setValue(data.ID);
                this.submitted = false;
                this._formSaved = true;
                this.SavedItem = this.Item;
                if(this.translateService){
                    //this.translateService.get(this.modelData.MainTitle)
                    this.translateService.get(this.modelData.BreadcrumbLabel != null ? this.modelData.BreadcrumbLabel : (this.modelData.MainList.ModelName).toUpperCase() + '.SINGULAR')
                        .subscribe(translate => {
                            // this.notificationsService.success('Unos ' + translate, 'Uspešno sačuvano');
                            this.toastrService.success('Unos ' + translate, 'Uspešno sačuvano');
                            this.saveItemCompleted.next();
                            this.ItemsLoaded.next(true);
                        });
                    }
                    else{
                        this.saveItemCompleted.next();
                        this.ItemsLoaded.next(true);
                    }
                        
            }, 
            (error) => { this.submitted = false;
                        this.SaveProcessed.emit(true);
                        throw error; }
            )
        }
        else{
            // this.notificationsService.warn('Provera', 'Forma nije validna. Proverite unete podatke.');
            this.toastrService.warning('Provera', 'Forma nije validna. Proverite unete podatke.');
            this.SaveProcessed.emit(true);
        }
    }

    // 26.12.2024 Sneža, nova metoda SaveItem zbog problema slanja PEF, ako nešto menjam, a ne idem na dugme snimi već na pošalji
    //u kodu kod slanja PEF se poziva SaveItem(), ali se asinhrono izvršava, tako da ne uspe da dočeka da prvo snimi, pa da pošalje, pa odmah pošalje
    //zbog toga prebacivanje da vrati Promise, da bi se na klijentu sačekao rezultat izvršavanja, i onda u then nastavilo izvršavanje
    SaveItem() : Promise<any>{
        this.submitted = true;

        if(this.baseFormGroup.valid){
            if(this.modelData.MainList.FormType == 'reactive'){
                let tempID = this.Item.ID;
                this.Item = this.baseFormGroup.getRawValue();
                this.Item.ID = tempID;
            }
            if(this._parentProperty){
                if(!this.Item.hasOwnProperty(this._parentProperty.Name)) {
                    throw 'Item does not have parent property ' + this._parentProperty.Name;
                }
                this.Item[this._parentProperty.Name] = this._parentProperty.Value;
                if(!this.Item[this._parentProperty.Name] || this.Item[this._parentProperty.Name] <= 0)
                {
                    // this.notificationsService.warn('Dokument nije sačuvan', 'Unos stavke');
                    this.toastrService.warning('Dokument nije sačuvan', 'Unos stavke');
                    return;
                }
            }
            if(this.modelData.MainList.GetParameters != null && this.modelData.MainList.GetParameters.length > 0){
                let parameterName = this.modelData.MainList.GetParameters[0].Name[0].toUpperCase() + this.modelData.MainList.GetParameters[0].Name.substring(1);
                this.Item[parameterName] = this.modelData.MainList.GetParameters[0].Value;
                //this.Item[this.modelData.MainList.GetParameters[0].Name] = this.modelData.MainList.GetParameters[0].Value;
            }
           

            return this.baseDataService.Save(this.modelData.MainList.ModelName, this.Item, this.modelData.MainList.ModelClass, this.modelData.MainList.ShortModelClass)
                .toPromise().then((data: T) => {
                    //console.log('BaseUpdateComponent:'+ "Save");
                    //this.containerService.EmitItem(data);
                    this.submitted = false;
                    this.ItemSaved.emit(data);
                    this.SavedViewItem = data;
                    //this.Item = <T>{ID: -1};
                    this.Item.ID = data.ID;
                    if(data[this.modelData.MainList.DefaultPropertyName] && this.Item[this.modelData.MainList.DefaultPropertyName]) {
                        this.Item[this.modelData.MainList.DefaultPropertyName] = data[this.modelData.MainList.DefaultPropertyName];
                    }
                    //this.baseDataService.GetByID(this.modelData.MainList.ModelName, this.Item.ID, this.modelData.MainList.ModelClass)
                        //.subscribe((data: T) => {
                            //if(this.Item['BrojDokumenta'] != data['BrojDokumenta'])
                                //this.notificationsService.warn('Sačuvani dokument sadrži automatski korigovane podatke');
                            //this.Item = data;
                            //this.baseFormGroup.setValue(this.Item);
                            this.baseFormGroup.patchValue(this.Item);
                            //this.SavedItem = this.baseFormGroup.getRawValue();
                        //})
                    //this.baseFormGroup.get('ID').setValue(data.ID);
                    this.submitted = false;
                    this._formSaved = true;
                    this.SavedItem = this.Item;
                    if(this.translateService){
                        //this.translateService.get(this.modelData.MainTitle)
                        this.translateService.get(this.modelData.BreadcrumbLabel != null ? this.modelData.BreadcrumbLabel : (this.modelData.MainList.ModelName).toUpperCase() + '.SINGULAR')
                            .subscribe(translate => {
                                // this.notificationsService.success('Unos ' + translate, 'Uspešno sačuvano');
                                this.toastrService.success('Unos ' + translate, 'Uspešno sačuvano');
                                this.saveItemCompleted.next();
                                this.ItemsLoaded.next(true);
                            });
                        }
                        else{
                            this.saveItemCompleted.next();
                            this.ItemsLoaded.next(true);
                        }
                            
                }, 
                (error) => { this.submitted = false;
                            this.SaveProcessed.emit(true);
                            throw error; 
                            }
                )
                // .catch((error)=>{
                //     console.error('Greška prilikom čuvanja:', error);
                // })
            }
            else{
                // this.notificationsService.warn('Provera', 'Forma nije validna. Proverite unete podatke.');
                this.toastrService.warning('Provera', 'Forma nije validna. Proverite unete podatke.');
                this.SaveProcessed.emit(true);
                // return Promise.reject('Forma nije validna');
            }
    }

   
    AddItem(){
        this.Item = <T>{ ID: -1, Useridlk: 0};
    }
    
    getFormGroupFromModel(){
        let masterObject: T = (new BaseEntity).GetInstance(this.modelData.MainList.ModelClass) as T;
        let detailObject: T = this.modelData.MainList.DetailList && this.modelData.MainList.DetailList.length > 0 ? (new BaseEntity).GetInstance(this.modelData.MainList.DetailList[0].ModelClass) as T : null;
        // this.baseFormGroup = new FormGroup({});
        this.genFgFromModel(masterObject, detailObject);
        // this.SavedItem = this.baseFormGroup.getRawValue();
        // this.baseFormGroup.markAsPristine();
        // this.baseFormGroup.markAsUntouched();
    }
    
    genFgFromModel(masterObject, detailObject){
        // masterObject=this.emptyMaster;
        // detailObject=this.emptyDetail;
        //var fg: FormGroup=new FormGroup({});
        let excludedProperties = ['Editable', 'Deletable'];
        for (let key in masterObject) {
            if(excludedProperties.indexOf(key) == -1){
                if (masterObject[key]==null || masterObject[key].ID==null){
                    this.baseFormGroup.addControl(key, new FormControl(masterObject[key]));
                }
                else{
                    this.baseFormGroup.addControl(key, this.genFgFromModel(detailObject, null));
                }
            }
        }
        this.emptyMaster=masterObject;
        this.emptyDetail=detailObject;
        return this.baseFormGroup;
      }
    
      addValidatorToFc(controlName: string, controlValidator: ValidationErrors, validatorName: string, message: string, parameter: any = {}){
        let controlObj=this.getControl(controlName);
        if(controlObj == null) {
            throw new ReferenceError('Model ' + this.modelData.MainList.ModelName + ' does not have property ' + controlName);
        }
        controlObj.setValidators(
          Validators.compose([controlObj.validator, controlValidator])
        );
        if(this.errorMessages[controlName] == null)
            this.errorMessages[controlName] = [];
        if(this.errorMessages[controlName].filter(validator => validator.type == validatorName).length == 0)
            this.errorMessages[controlName].push({ type: validatorName, message: message, parameter: parameter});
      }

      getControl(controlName: string){
        var splitted =controlName.split(".");
        var controlObj:any =this.baseFormGroup;
    
        for (let entry of splitted) {
          controlObj=controlObj.controls[entry];
        }
    
        return controlObj;
      }
    
      focus(){
          //alert('baseUpdateComponent focus');
          if(this.autofocusElement){
            if (this.autofocusElement instanceof DropdownComponent || this.autofocusElement instanceof DropdownPicklistComponent
              || this.autofocusElement instanceof InputComponent || this.autofocusElement instanceof BaseNumberInput
              || this.autofocusElement instanceof DatePickerPopup2Component || this.autofocusElement instanceof MultiselectComponent
              || this.autofocusElement instanceof TextAreaComponent || this.autofocusElement instanceof DateTimePickerPopupComponent)
                this.autofocusElement.focus();
            else
                this.autofocusElement.nativeElement.focus();
          }
      }

      //LoadItemView(){
          //return this.baseDataService.GetByID(this.modelData.MainList.ModelName, this.Item.ID, this.modelData.MainList.ShortModelClass);
      //}

      IsFormTouched(){
          return this.baseFormGroup.touched;
      }

      Print() {
        let print = true;
        if (!this.canDeactivate()) {
          this.modalService
            .ShowConfirmationDialog(
              "Obaveštenje",
              "Dokument nije sačuvan. Sačuvaj i štampaj?",
              "question",
              ConfirmationDialogButtons.YesNo
            )
            .result.then((dialogResult) => {
      
              if (dialogResult === true) { 
                this.SaveItem()
                  .then(() => {             
                    if (
                      this.baseInlineContainer &&
                      this.baseInlineContainer.baseInlineUpdateComponent &&
                      this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent &&
                      !this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.canDeactivate()
                    ) {
                      this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.SaveItem();
                    }
                    if (
                      this.baseInlineContainer1 &&
                      this.baseInlineContainer1.baseInlineUpdateComponent &&
                      this.baseInlineContainer1.baseInlineUpdateComponent.baseUpdateComponent &&
                      !this.baseInlineContainer1.baseInlineUpdateComponent.baseUpdateComponent.canDeactivate()
                    ) {
                      this.baseInlineContainer1.baseInlineUpdateComponent.baseUpdateComponent.SaveItem();
                    }
                    if (
                      this.baseInlineContainer2 &&
                      this.baseInlineContainer2.baseInlineUpdateComponent &&
                      this.baseInlineContainer2.baseInlineUpdateComponent.baseUpdateComponent &&
                      !this.baseInlineContainer2.baseInlineUpdateComponent.baseUpdateComponent.canDeactivate()
                    ) {
                      this.baseInlineContainer2.baseInlineUpdateComponent.baseUpdateComponent.SaveItem();
                    }

                    if (this.baseInlineContainer 
                        && this.baseInlineContainer.baseInlineUpdateComponent 
                        && this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent
                        && this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.nestedInlineContainer
                        && this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.nestedInlineContainer.baseInlineUpdateComponent
                        && this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.nestedInlineContainer.baseInlineUpdateComponent.baseUpdateComponent
                        && !this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.nestedInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.canDeactivate())
                        this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.nestedInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.SaveItem();


                    this.executePrint(true);
                  })
                  .catch((error) => {
                    // this.notificationsService.error('Greška', 'Dokument nije sačuvan.');
                    this.toastrService.error('Greška', 'Dokument nije sačuvan.');
                  });
              } else if (dialogResult === false) { 
                print = false;
              } else {
                console.warn('Nepoznata vrednost dijaloga:', dialogResult);
              }
            });
        } else {
          this.executePrint(print);
        }
      }
      
      private executePrint(print: boolean) {
        if ((print && this.baseFormGroup.valid) || (print && this.baseFormGroup.disabled)) {
          this.translateService
            .get(this.modalService.ConvertPluralToSingular(this.modelData.BreadcrumbLabel))
            .subscribe((translate) => {
              this.modalService
                .ShowPrintDialog(
                  translate,
                  this.modelData.MainList.EnablePrintAccountSelection,
                  false,
                  this.Item["PodVrstaDokumentaStavkaID"]
                )
                .result.then(
                  (value) => {
                    let controllerName: string;
                    let controllerMethodName: string;
                    if (this.modelData.MainList.PrintController) {
                      controllerName = this.modelData.MainList.PrintController;
                      controllerMethodName = "Printaj";
                    } else {
                      controllerName = this.modelData.MainList.ModelName;
                      controllerMethodName = this.modelData.MainList.PrintName;
                    }
      
                    this.baseDataService
                      .GetFile(controllerName, controllerMethodName, {
                        ReportPars: [
                          { Name: "ID", Value: this.Item.ID },
                          { Name: "PrintMethod", Value: this.modelData.MainList.PrintName },
                        ],
                        WipsPars: {
                          parReportTitle: value.Title,
                          parReportSubtitle: value.SubTitle,
                          parPageNoYes: value.ShowPageCount,
                          parPageNoPosition: value.PageNoPosition,
                          parTimeZoneInfo: "Central Europe Standard Time",
                          parHeaderType: value.ReportHeaderTypes,
                          parPageFooterType: value.ReportPageTypes,
                          parCompanyAccounts: value.FirmaZrcs,
                          parIzvestajId: value.TipDokumenta,
                          parOdloziIUEregistrator: value.Eregistrator,
                        },
                      })
                      .subscribe((file) => {
                        let fileUrl = URL.createObjectURL(file);
                        window.open(fileUrl);
                      });
                  },
                  () => {}
                );
            });
        }
      }
      
      

    //   canDeactivate(){
    //     //console.log('BaseUpdateComponent:'+ "canDeactivate");
    //       //return !this.baseFormGroup.dirty || this._formSaved;
    //       //console.log('Saved item: ' + JSON.stringify(this.SavedItem));
    //       //console.log('Item: ' + JSON.stringify(this.baseFormGroup.getRawValue()));
    //       return (!this.SavedItem || JSON.stringify(this.SavedItem).toLowerCase() === JSON.stringify(this.baseFormGroup.getRawValue()).toLowerCase())
    //             && (!this.baseInlineContainer || (this.baseInlineContainer && 
    //                 this.baseInlineContainer.baseInlineUpdateComponent && 
    //                 this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent && 
    //                 this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.canDeactivate()))
    //             && (!this.baseInlineContainer1 || (this.baseInlineContainer1 && 
    //                 this.baseInlineContainer1.baseInlineUpdateComponent && 
    //                 this.baseInlineContainer1.baseInlineUpdateComponent.baseUpdateComponent && 
    //                 this.baseInlineContainer1.baseInlineUpdateComponent.baseUpdateComponent.canDeactivate()))
    //                 ;
    //   }

      canDeactivate(): boolean {
        if (!this.baseFormGroup) return true;

        const current = this.baseFormGroup.getRawValue();
        const saved = this.SavedItem;

        const isEqual = !saved || ObjectCompareUtil.areEqual(saved, current);

        // 🔍 DEBUG (zadrži ovo!)
        const w: any = (typeof window !== 'undefined') ? window : null;
        if (w && w.__YT_FW_DEBUG_UNSAVED === true && !isEqual) {
            const diffs = ObjectCompareUtil.getDiffs(saved, current);
            console.log('Unsaved diffs:', diffs);
        }

        return isEqual
            && (!this.baseInlineContainer || 
                this.baseInlineContainer?.baseInlineUpdateComponent?.baseUpdateComponent?.canDeactivate())
            && (!this.baseInlineContainer1 || 
                this.baseInlineContainer1?.baseInlineUpdateComponent?.baseUpdateComponent?.canDeactivate())
            && (!this.baseInlineContainer2 || 
                this.baseInlineContainer2?.baseInlineUpdateComponent?.baseUpdateComponent?.canDeactivate())
            && (!this.baseInlineContainer?.baseInlineUpdateComponent?.baseUpdateComponent?.nestedInlineContainer ||
                this.baseInlineContainer?.baseInlineUpdateComponent?.baseUpdateComponent?.nestedInlineContainer?.baseInlineUpdateComponent?.baseUpdateComponent?.canDeactivate());

            
    }

      Reset(loadItem: boolean = false): Observable<boolean>{
        if (this.callDelete){
            this.callDelete = false;
            return this.ResetValues(true, loadItem).pipe(
                switchMap(() => of(true))
            );
        }
        if (!this.canDeactivate()) {
            return from(
                this.modalService.ShowConfirmationDialog(
                    "Obaveštenje",
                    "Postoje promene u tekućim podacima. Akcijom koju ste pokrenuli promene neće biti sačuvane.",
                    "question",
                    ConfirmationDialogButtons.ConfirmCancel
                ).result
            ).pipe(
                switchMap((result) => {
                    if (result) {
                        return this.ResetValues(true, loadItem).pipe(
                            switchMap(() => of(true))
                        );
                    } else {
                        return of(false);
                    }
                }),
                catchError((error) => {
                    console.error('Error during reset:', error);
                    return of(false);
                })
            );
        } 
        else {
            return this.ResetValues(true, loadItem).pipe(
                switchMap(() => of(true))
            );
        }
    }

    

    ResetValues(reset, loadItem){
        //console.log('BaseUpdateComponent:'+ "ResetValues");
        if(reset && this.Item.ID == -1 || (this.Item.ID > 0 && this.Item[this.modelData.MainList.DefaultPropertyName] == null)){
            this.baseFormGroup.reset();
            this.baseFormGroup.disable();
            this.SavedItem = this.baseFormGroup.getRawValue();            
          }
          else if(reset && this.Item && this.Item.ID && this.Item.ID > 0){
            if(loadItem)
                this.Load(this.Item.ID).subscribe();
            if(!loadItem){
                this.baseFormGroup.reset();
                this.baseFormGroup.disable();
                this.SavedItem = this.baseFormGroup.getRawValue();
            }
          }
          if(reset){
            if(this.baseInlineContainer){
                this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.baseFormGroup.reset();
                this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.SavedItem = this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.baseFormGroup.getRawValue();
                this.baseInlineContainer.baseInlineUpdateComponent.collapsed = true;
            }
            if(this.baseInlineContainer1){
                this.baseInlineContainer1.baseInlineUpdateComponent.baseUpdateComponent.baseFormGroup.reset();
                this.baseInlineContainer1.baseInlineUpdateComponent.baseUpdateComponent.SavedItem = this.baseInlineContainer1.baseInlineUpdateComponent.baseUpdateComponent.baseFormGroup.getRawValue();
                this.baseInlineContainer1.baseInlineUpdateComponent.collapsed = true;
            }
            if(this.baseInlineContainer2){
                this.baseInlineContainer2.baseInlineUpdateComponent.baseUpdateComponent.baseFormGroup.reset();
                this.baseInlineContainer2.baseInlineUpdateComponent.baseUpdateComponent.SavedItem = this.baseInlineContainer2.baseInlineUpdateComponent.baseUpdateComponent.baseFormGroup.getRawValue();
                this.baseInlineContainer2.baseInlineUpdateComponent.collapsed = true;
            }

            if(this.baseInlineContainer &&
                this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.nestedInlineContainer){
                this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.nestedInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.baseFormGroup.reset();
                this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.nestedInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.SavedItem = this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.nestedInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.baseFormGroup.getRawValue();
                this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.nestedInlineContainer.baseInlineUpdateComponent.collapsed = true;
            }

            // let buttonsConfig = this.modelData.MainList.DefaultListButtonsConfig;
            //this.buttonsConfig.AddButtonConfig.Enable = true;
            //this.buttonsConfig.DeleteButtonConfig.Enable = true;
            //this.buttonsConfig.SaveButtonConfig.Enable = true;
            //this.buttonsConfig.LockButtonConfig.Enable = true;
            this.buttonsConfig.AddButtonConfig.Enable = true;
            this.buttonsConfig.DeleteButtonConfig.Enable = false;
            this.buttonsConfig.SaveButtonConfig.Enable = false;
            this.buttonsConfig.LockButtonConfig.Enable = false;
            this.buttonsConfig.ResetButtonConfig.Enable = false;
            
          }
        return of(reset);
    }
      Delete(){
          this.translateService.get(['FW.ACTION.DELETE.ACTIONNAME', 'FW.ACTION.DELETE.MESSAGE.SUCCESS', 'FW.ACTION.DELETE.QUESTION'])
            .subscribe(translate => {
                this.modalService.ShowConfirmationDialog(
                    translate['FW.ACTION.DELETE.ACTIONNAME'],
                    translate['FW.ACTION.DELETE.QUESTION'] + this.Item[this.modelData.MainList.DefaultPropertyName] + '?',
                    'question'
                )
                .result 
                    .then((result) => {
                        if(result){
                            this.baseDataService.Delete(this.modelData.MainList.ModelName, this.Item.ID)
                                .subscribe(data => {
                                    this.callDelete = true;
                                    // this.notificationsService.success(translate['FW.ACTION.DELETE.MESSAGE.SUCCESS'], this.Item[this.modelData.MainList.DefaultPropertyName]);
                                    this.toastrService.success(translate['FW.ACTION.DELETE.MESSAGE.SUCCESS'], this.Item[this.modelData.MainList.DefaultPropertyName]);
                                    this.Item = <T>{ ID: this.Item.ID };                                    
                                    this.ItemDeleted.emit(this.Item);
                                })
                        }
                    })
            })
      }

      protected getFormControlData(modelName: string, podvrstaDokumentaStavkaID: number = null){
          let parameters = [];
          parameters.push(new QueryParameter('model', modelName));
          if(podvrstaDokumentaStavkaID)
            parameters.push(new QueryParameter('podvrstaDokumentaStavkaID', podvrstaDokumentaStavkaID));
          let getName = podvrstaDokumentaStavkaID ? 'getByModelAndPVSID' : 'getByModel';

          if(modelName){
            this.baseDataService.Get('formControl', getName, parameters, FormControlData)
                .subscribe(data => {
                    this.formControlData = data;
                    //this.isVisible = data;
                    this.fcd = data;
                    if(data){
                    Object.keys(data).forEach(item => {
                        if(data[item]['IsRequired'])
                            this.addValidatorToFc(item, Validators.required, 'required', 'VALIDATION.REQUIRED');
                        })
                    }
                })
            }
      }

      IsVisible(controlID: string){
          let isVisibleCondition;
          let value = false;
          if(this.formControlData){
            //isVisibleCondition = this.formControlData.find(item => item.ControlID == controlID).IsVisibleCondition;
            //var runable = ts.transpile(isVisibleCondition);
            //value = this.formControlData.find(item => item.ControlID == controlID).IsVisible;
          }
          return value;
      }

      IsRequired(formControlName: string){
          const formControl = this.baseFormGroup.get(formControlName);
          if(!formControl || !formControl.validator)
            return false;

        const validator = formControl.validator({} as AbstractControl);
        return (validator && validator.required);
      }

    //   getViewItem() {
    //       if(this.Item && this.Item.ID > -1)
    //       return this.baseDataService.Get(this.modelData.MainList.ModelName, "getViewItemByID", [ new QueryParameter('ID', this.Item.ID) ], this.modelData.MainList.ShortModelClass)
    //         .subscribe(data => {
    //             if(data)
    //                 this.ItemSaved.emit(<any>data as T);
    //         })
    //   }
      
       getViewItem(): Observable<any[T] | null> {
          if(this.Item && this.Item.ID > -1)
            return this.baseDataService.Get(this.modelData.MainList.ModelName, "getViewItemByID", [ new QueryParameter('ID', this.Item.ID) ], this.modelData.MainList.ShortModelClass);
          return of(null);
      }

      LockUnLock(): Observable<T>{
        if(this.Item && this.Item.ID > -1){        
            if (this.Item.Editable && !this.canDeactivate()) {                 
                return this.translateService.get(["FW.LOCK.TITLE","FW.LOCK.QUESTION.DATACHANGE"])
                .pipe(
                    switchMap(translate => {
                    return from(
                    this.modalService.ShowConfirmationDialog(translate["FW.LOCK.TITLE"]
                    , translate["FW.LOCK.QUESTION.DATACHANGE"]
                    , 'question'
                    , ConfirmationDialogButtons.ConfirmCancel
                    ).result).pipe(
                        switchMap(result => {
                        if (result){

                            // const firstSave = from(this.SaveItem());
                            // console.log("Snimanje zaglavlja");
                            // if (this.baseInlineContainer && 
                            //     this.baseInlineContainer.baseInlineUpdateComponent && 
                            //     this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent){
                            //         const secondSave = from(
                            //             this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.SaveItem()                                        
                            //         );
                            //         console.log("Snimanje stavki");
                            //         firstSave.pipe(
                            //             switchMap(() => secondSave)
                            //         );
                            //         console.log("Zavšeno snimanje zaglavlja i stavki, ide u LockUnLockService");
                            //         return secondSave.pipe(
                            //             switchMap(() =>  this.LockUnLockService())
                            //         );
                                    
                            //     }
                            // else{
                            //     return firstSave.pipe(
                            //         switchMap(() => this.LockUnLockService())
                            //     );
                            // }

                            return this.saveItems().pipe(
                                switchMap(()=>this.LockUnLockService())
                            )
                                                 
                        }
                        else{
                            return of(this.Item);
                        }
                    })              
                );                  
            })
        );
            }
            else{
                return this.translateService.get(["FW.LOCK.TITLE","FW.LOCK.QUESTION.LOCK","FW.LOCK.QUESTION.UNLOCK"])
                .pipe(
                    switchMap(translate => {
                    return from(
                    this.modalService.ShowConfirmationDialog(translate["FW.LOCK.TITLE"]
                    , this.Item.Editable ? translate["FW.LOCK.QUESTION.LOCK"] : translate["FW.LOCK.QUESTION.UNLOCK"]
                    , 'question'
                    , ConfirmationDialogButtons.ConfirmCancel
                    ).result).pipe(
                        switchMap(result => {
                        if (result)
                            return this.LockUnLockService();  
                        else 
                            return of(this.Item);   
                        }
                    ));
                }));                
            }

           
        }
        else
            return of(this.Item);
      }

      private saveItems(): Observable<any> {
        
        if (
            this.baseInlineContainer && 
            this.baseInlineContainer.baseInlineUpdateComponent && 
            this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent &&
            !this.baseInlineContainer.baseInlineUpdateComponent.collapsed &&
            this.baseInlineContainer1 && 
            this.baseInlineContainer1.baseInlineUpdateComponent && 
            this.baseInlineContainer1.baseInlineUpdateComponent.baseUpdateComponent &&
            !this.baseInlineContainer1.baseInlineUpdateComponent.collapsed &&
            this.baseInlineContainer2 && 
            this.baseInlineContainer2.baseInlineUpdateComponent && 
            this.baseInlineContainer2.baseInlineUpdateComponent.baseUpdateComponent &&
            !this.baseInlineContainer2.baseInlineUpdateComponent.collapsed &&
            this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.nestedInlineContainer && 
            this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.nestedInlineContainer.baseInlineUpdateComponent && 
            this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.nestedInlineContainer.baseInlineUpdateComponent.baseUpdateComponent &&
            !this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.nestedInlineContainer.baseInlineUpdateComponent.collapsed
        ){
            const firstSave = from(this.SaveItem());
            const secondSave = from(
                this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.SaveItem()
            );
            const thirdSave = from(
                this.baseInlineContainer1.baseInlineUpdateComponent.baseUpdateComponent.SaveItem()
            );
            const fourthSave = from(
                this.baseInlineContainer2.baseInlineUpdateComponent.baseUpdateComponent.SaveItem()
            );
            const fifthSave = from(
                this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.nestedInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.SaveItem()
            );

            // Kombinujte pozive, jedan nakon drugog
            return firstSave.pipe(
            switchMap(() => secondSave),
            switchMap(() => thirdSave),
            switchMap(() => fourthSave),
            switchMap(() => fifthSave)
            );
        }
        else{
            return from(this.SaveItem());
        }
    }

    protected debugUnsavedChanges(saved: any, current: any): void {
        try {
            const normSaved = this.buildComparableSnapshot(saved);
            const normCurrent = this.buildComparableSnapshot(current);
            const diffs = this.diffSnapshots(normSaved, normCurrent);

            // eslint-disable-next-line no-console
            console.groupCollapsed(`[YT FW] unsaved changes | model=${this.modelData?.MainList?.ModelName} | id=${this.Item?.ID} | diffs=${diffs.length}`);
            // eslint-disable-next-line no-console
            console.table(diffs.slice(0, 80));
            if (diffs.length > 80) {
                // eslint-disable-next-line no-console
                console.log(`... još ${diffs.length - 80} razlika (skraćeno)`);
            }
            // eslint-disable-next-line no-console
            console.groupEnd();

            // dump na window za copy/paste
            const w: any = (typeof window !== 'undefined') ? (window as any) : null;
            if (w) {
                w.__YT_FW_LAST_UNSAVED_DIFFS = diffs;
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn('[YT FW] debugUnsavedChanges failed', e);
        }
    }

    protected buildComparableSnapshot(obj: any): any {
        const walk = (v: any): any => {
            const norm = this.normalizeComparable(v);

            if (norm == null) return norm;

            if (Array.isArray(norm)) {
                return norm.map(x => walk(x));
            }

            if (typeof norm === 'object') {
                const result = {};
                Object.keys(norm).sort().forEach(k => {
                    result[k] = walk(norm[k]);
                });
                return result;
            }

            return norm;
        };

        return walk(obj);
    }

    protected normalizeComparable(v: any): any {
        if (v == null) return v;

        // "" (ili whitespace) često dolazi iz input komponenti; tretiraj kao null da ne pravi lažnu razliku sa backend null.
        if (typeof v === 'string') {
            const trimmed = v.trim();
            if (trimmed === '') return null;
        }

        // NgbDate
        if (v?.year != null && v?.month != null && v?.day != null) {
            return `${Number(v.year)}-${Number(v.month)}-${Number(v.day)}`;
        }

        // Date / string
        if (v instanceof Date) return v.toISOString();

        if (typeof v === 'string') {
            const d = new Date(v);
            if (!Number.isNaN(d.getTime()) && v.length >= 10) {
                return d.toISOString();
            }
            return v.trim();
        }

        if (typeof v === 'number') {
            return Number.isFinite(v) ? v : null;
        }

        return v;
    }
    
    private diffSnapshots(a: any, b: any): Array<{ path: string; a: any; b: any }> {
        const out: Array<{ path: string; a: any; b: any }> = [];
        const walk = (x: any, y: any, path: string) => {
            if (x === y) return;
            const isArrX = Array.isArray(x);
            const isArrY = Array.isArray(y);
            if (isArrX || isArrY) {
                if (!isArrX || !isArrY) {
                    out.push({ path, a: x, b: y });
                    return;
                }
                if (x.length !== y.length) {
                    out.push({ path, a: x, b: y });
                    return;
                }
                for (let i = 0; i < x.length; i++) walk(x[i], y[i], `${path}[${i}]`);
                return;
            }
            const isObjX = x && typeof x === 'object';
            const isObjY = y && typeof y === 'object';
            if (isObjX && isObjY) {
                const keys = new Set([...Object.keys(x), ...Object.keys(y)]);
                keys.forEach(k => walk(x[k], y[k], path ? `${path}.${k}` : k));
                return;
            }
            out.push({ path, a: x, b: y });
        };
        walk(a, b, '');
        return out.filter(d => d.path !== '');
    }

    LockUnLockService(): Observable<T>{
        console.log("Ulazak u LockUnLockService");
        return this.baseDataService.LockUnLock(this.modelData.MainList.ModelName, this.Item, this.modelData.MainList.ModelClass)
                .pipe(
                    map((data: any) => {
                        if(data){
                            this.Load(data["ID"]);
                            let message = data['Useridlk'] > 0 ? 'FW.LOCK.LOCKED' : 'FW.LOCK.UNLOCKED';
                            this.translateService.get(['FW.LOCK.TITLE', 'FW.LOCK.LOCKED', 'FW.LOCK.UNLOCKED'])
                            .subscribe(translate => {
                                // this.notificationsService.success(translate['FW.LOCK.TITLE'], data['Useridlk'] > 0 ? translate['FW.LOCK.LOCKED'] : translate['FW.LOCK.UNLOCKED']);
                                this.toastrService.success(translate['FW.LOCK.TITLE'], data['Useridlk'] > 0 ? translate['FW.LOCK.LOCKED'] : translate['FW.LOCK.UNLOCKED']);
                            })   
                            return data;                      
                        }
                        else{
                            this.translateService.get(['FW.LOCK.TITLE', 'FW.LOCK.ERROR'])
                            .subscribe(translate => {
                                // this.notificationsService.warn(translate['FW.LOCK.TITLE'], translate['FW.LOCK.ERROR']);
                                this.toastrService.warning(translate['FW.LOCK.TITLE'], translate['FW.LOCK.ERROR']);
                            })
                        }
                    }),
                    catchError((error: HttpErrorResponse) => {
                        return throwError(error);
                    })
                )       
    }

    // saveInitialControlDisabledStatus() {
    //     Object.keys(this.baseFormGroup.controls).forEach((controlName) => {
    //       const control = this.baseFormGroup.get(controlName);
    //       if (control) {
    //         this.initialControlDisabledStatus[controlName] = control.disabled;
    //       }
    //     });

    //     console.log('Control Disabled Status:', this.initialControlDisabledStatus);
    // }

    // restoreControlDisabledStatus() {
    // // Restore disabled status based on values stored in controlDisabledStatus
    // Object.keys(this.baseFormGroup.controls).forEach((controlName) => {
    //     const control = this.baseFormGroup.get(controlName);
    //     if (control) {
    //         if (this.initialControlDisabledStatus[controlName]==true) {
    //             control.disable();
    //         } else {
    //             control.enable();
    //         }
    //     }
    //   });
    // }

    mapDisabledState(form: FormGroup | FormArray) {
        const result = { rootFormDisabledStatus: form.disabled };
        Object.keys(form.controls).forEach(key => {
          const abstractControl = form.controls[key];
          if (abstractControl instanceof FormGroup || abstractControl instanceof FormArray) {
            result[key] = this.mapDisabledState(abstractControl);
          } else {
            result[key] = abstractControl.disabled;
          }
        });
        return result;
    }

    restoreFormDisabledState(form: FormGroup | FormArray, keymap: { [pathKey: string]: any }) {
        Object.keys(keymap).forEach(function (key) {
          if (key === 'rootFormDisabledStatus') {
            if (keymap[key]) {
              form.disable({ onlySelf: true, emitEvent: false });
            }
          } else {
            const abstractControl: FormGroup = form.controls[key];
            const result = keymap[key];
            if (typeof result === 'object') {
              this.restoreFormDisabledState(abstractControl, keymap[key]);
            } else if (result) {
              abstractControl.disable({ onlySelf: true, emitEvent: false });
            }
          }
        });
      }

      CanCloseWithoutReset(): Observable<boolean> {
        if (this.callDelete) {
            this.callDelete = false;
            return of(true);
        }

        if (this.canDeactivate()) {
            return of(true);
        }

        return from(
            this.modalService.ShowConfirmationDialog(
                "Obaveštenje",
                "Postoje promene u tekućim podacima. Akcijom koju ste pokrenuli promene neće biti sačuvane.",
                "question",
                ConfirmationDialogButtons.ConfirmCancel
            ).result
        ).pipe(
            map(result => !!result),
            catchError(() => of(false))
        );
    }
}

